import { closeModal } from "action/modal/closeModal";
import { openModal } from "action/modal/openModal";
import { addItem } from "action/shopping-cart/addItem";
import { useDispatch } from "react-redux";
import styles from "./card-actions.module.scss";
import SaveButton from "./SaveButton";

const CardActions = ({ product = {} }: any) => {
  const dispatch = useDispatch();

  const handleClickCart = (e: any) => {
    e.stopPropagation();
    // eslint-disable-next-line no-shadow
    dispatch(closeModal());
    dispatch(addItem(product, undefined, {},
      ({ fitmentOptionsDetails, updatedProduct }) => dispatch(openModal("shoppingCart", { fitmentOptionsDetails, product: updatedProduct }))))
      .catch(() => {});
  };

  if (product.outOfStock) {
    return null;
  }

  return (
    <div className={styles.card_actions}>
      <SaveButton product={product} />

      <button
        type="button"
        className={`btn btn-default ${styles.action_button} ${styles.btn_cart}`}
        onClick={handleClickCart}
      >

        <i className={`${styles.shopping_cart_icon} fa fa-shopping-cart`} />
      </button>
    </div>
  );
};

export default CardActions;
